export default __webpack_public_path__ + "static/media/DIS.eca6305d.svg";